import { z } from 'zod';
import { getBackendEventExtensionsDir } from '@wix/cli-astro-definitions';
import {
  VALID_PATH_REGEX,
  pathAvailableValidation,
} from '../../../dev-center/components/validations/common.js';
import type { ExtensionDef } from '../generate-schema/types.js';
import { defineField } from '../generate-schema/definitions.js';
import { generateEvent } from './generate.js';

const schema = z.object({
  extensionType: z.literal('EVENT'),
  folder: z
    .string()
    .regex(VALID_PATH_REGEX)
    .describe(
      defineField({
        title: 'Event folder',
        description: 'Lowercase alphanumeric and hyphens only',
      })
    ),
});

export const event: ExtensionDef<typeof schema> = {
  title: 'Event',
  description: 'A backend event handler',
  group: 'Backend',
  documentation:
    'https://dev.wix.com/docs/wix-cli/guides/extensions/backend-extensions/events/add-event-extensions',
  zodSchema: schema,
  validate: async (projectFolder, data) => {
    const isAvailable = pathAvailableValidation(
      getBackendEventExtensionsDir(projectFolder)
    )(data.folder);
    return isAvailable
      ? null
      : 'The event folder must be unique, please choose a folder that has not been used yet in your application.';
  },
  generate: ({ projectFolder, data }) =>
    generateEvent(projectFolder, data.folder),
};
